var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMisReportsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 4.18774C0.5 2.25475 2.067 0.687744 4 0.687744C5.933 0.687744 7.5 2.25475 7.5 4.18774C7.5 6.12074 5.933 7.68774 4 7.68774C2.067 7.68774 0.5 6.12074 0.5 4.18774ZM6 4.18774C6 3.08317 5.10457 2.18774 4 2.18774C2.89543 2.18774 2 3.08317 2 4.18774C2 5.29231 2.89543 6.18774 4 6.18774C5.10457 6.18774 6 5.29231 6 4.18774Z",
    fill: "#E94D51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.18774C10.5 2.25475 12.067 0.687744 14 0.687744C15.933 0.687744 17.5 2.25475 17.5 4.18774C17.5 6.12074 15.933 7.68774 14 7.68774C12.067 7.68774 10.5 6.12074 10.5 4.18774ZM16 4.18774C16 3.08317 15.1046 2.18774 14 2.18774C12.8954 2.18774 12 3.08317 12 4.18774C12 5.29231 12.8954 6.18774 14 6.18774C15.1046 6.18774 16 5.29231 16 4.18774Z",
    fill: "#E94D51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 14.1877C0.5 12.2547 2.067 10.6877 4 10.6877C5.933 10.6877 7.5 12.2547 7.5 14.1877C7.5 16.1207 5.933 17.6877 4 17.6877C2.067 17.6877 0.5 16.1207 0.5 14.1877ZM6 14.1877C6 13.0832 5.10457 12.1877 4 12.1877C2.89543 12.1877 2 13.0832 2 14.1877C2 15.2923 2.89543 16.1877 4 16.1877C5.10457 16.1877 6 15.2923 6 14.1877Z",
    fill: "#E94D51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 14.1877C10.5 12.2547 12.067 10.6877 14 10.6877C15.933 10.6877 17.5 12.2547 17.5 14.1877C17.5 16.1207 15.933 17.6877 14 17.6877C12.067 17.6877 10.5 16.1207 10.5 14.1877ZM16 14.1877C16 13.0832 15.1046 12.1877 14 12.1877C12.8954 12.1877 12 13.0832 12 14.1877C12 15.2923 12.8954 16.1877 14 16.1877C15.1046 16.1877 16 15.2923 16 14.1877Z",
    fill: "#E94D51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisReportsFilled);
export default __webpack_public_path__ + "static/media/mis-reports-filled.1f6430eb800408c89b7db00a4fe04652.svg";
export { ForwardRef as ReactComponent };